// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "add-2cwld";
export { _1 as "__esModule", _2 as "add" }
export default { "__esModule": _1, "add": _2 }
